import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { BlogPage } from '@/components/marketing/BlogPage';

export const Route = createFileRoute('/_public/blog')({
  component: () => (
    <MarketingShell currentPath="/blog">
      <BlogPage />
    </MarketingShell>
  ),
});
